import {Bootstrap} from "./Bootstrap";

export class Scroll {
	// 初期化処理
	static init() {
		this.#initInView();
		this.#initWindowScroll();
	}
	
	static #initInView() {
		AOS.init({
			once: true,
			offset: 200
		});
		window.addEventListener('load', function () {
			AOS.refresh();
		});
		window.addEventListener('resize', function () {
			AOS.refresh();
		});
		setInterval(() => {
			AOS.refresh();
		}, 300);
	}
	
	static #initWindowScroll() {
		
		const svh = window.innerHeight;
		let svh_bit = svh / 4;
		
		if (document.body.classList.contains('is-sp')) {
			svh_bit *= 0.5;
		}
		window.addEventListener('scroll', (e) => {
			if (window.scrollY < svh_bit) {
				document.body.classList.remove('is-scroll-bit');
			} else {
				document.body.classList.add('is-scroll-bit');
			}
			if (window.scrollY < svh) {
				document.body.classList.remove('is-scroll');
			} else {
				document.body.classList.add('is-scroll');
			}
		});
		
		$(function () {
			$('a[href^="#"]').on("click", function (e) {
				e.preventDefault();
				var href = $(this).attr("href");
				if (href == '#' || href == "") return;
				Scroll.toScroll(href,500);
				
			});
		});
		
	}
	
	static toScroll(hash,duration){
		var top = $(hash).offset().top - Scroll.getHeaderHeight();
		$('body,html').stop().animate({
			scrollTop: top
		},{
			duration: 500,
			complete: () => {
				var diff = Math.abs(top-window.scrollY);
				console.log(top,window.scrollY);
				console.log('diff',diff);
				if(diff > 30){
					Scroll.toScroll(hash,100);
				}
			}
		});
	}
	
	static getHeaderHeight(){
		var h = $(".header").height();
		if(
			!Bootstrap.isSmartPhone() &&
			h < 60
		){
			h = 60;
		}
		return h;
	}
	
	
}
